// Cookie banner client behaviour moved from template to a JS module
const initCookieBanner = () => {
  const hideBanner = (choice) => {
    const parentBanner = document.getElementById('parent-cookie-banner')
    const acceptedBanner = document.getElementById('accepted-cookie-banner')
    const rejectedBanner = document.getElementById('rejected-cookie-banner')
    parentBanner.style.display = 'none'

    if (choice === 'accept') {
      acceptedBanner?.removeAttribute('hidden')
    } else {
      rejectedBanner?.removeAttribute('hidden')
    }
  }

  const init = () => {
    const banner = document.getElementById('cookie-banner')
    if (!banner) return

    const buttons = banner.querySelectorAll('[data-cookie-consent]')
    const acceptedBanner = document.getElementById('accepted-cookie-banner')
    const rejectedBanner = document.getElementById('rejected-cookie-banner')

    for (let i = 0; i < buttons.length; i++) {
      buttons[i].addEventListener('click', (event) => {
        const choice = event.currentTarget.getAttribute('data-cookie-consent')
        try {
          fetch('/cookies/consent', {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({ analytics: choice === 'accept' ? 'Yes' : 'No' })
          }).catch(() => {})
        } catch {
          // noop
        }

        hideBanner(choice)
      })
    }

    const hideButtons = banner.querySelectorAll('[data-hidden-consent]')
    for (let i = 0; i < hideButtons.length; i++) {
      hideButtons[i].addEventListener('click', () => {
        banner?.setAttribute('hidden', 'true')
        acceptedBanner?.setAttribute('hidden', 'true')
        rejectedBanner?.setAttribute('hidden', 'true')
      })
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init)
  } else {
    init()
  }
}

export { initCookieBanner }
